import React, { useContext } from "react";
import { InlineNotification } from "carbon-components-react";

import { PointsAndCreditsContext } from "../../PointsAndCreditsProvider";

const styles = require("./styles.module.scss");

const HeaderInfo = () => {
  const {
    rateStack: { locked, rate_stack },
  } = useContext(PointsAndCreditsContext);

  const rateStackIsEmpty = rate_stack.length === 0;
  const rateStackHasErrors = rate_stack.map(r => r.error).some(Boolean);

  if (!locked) {
    return (
      <div className={styles.container}>
        <InlineNotification
          notificationType="inline"
          kind="warning"
          role="alert"
          hideCloseButton
          lowContrast
          title="Rate not locked"
          subtitle={<div className={styles.subtext}>Must lock before selecting a rate below</div>}
        />
      </div>
    );
  }

  if (rateStackIsEmpty) {
    return (
      <div className={styles.container}>
        <InlineNotification
          notificationType="inline"
          kind="error"
          role="alert"
          hideCloseButton
          lowContrast
          title="Rate stack not available"
          subtitle={
            <div className={styles.subtext}>
              No rate stack for locked rate – please contact eng for help
            </div>
          }
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.instructions}>
        To choose a rate, select a row and then click the "Select this rate" button
      </div>
      {rateStackHasErrors && (
        <InlineNotification
          notificationType="inline"
          kind="info"
          role="alert"
          hideCloseButton
          lowContrast
          title="Some rates ineligible"
          subtitle={
            <div className={styles.subtext}>
              One or more rows are disabled because they represent ineligible rates
            </div>
          }
        />
      )}
    </div>
  );
};

export default HeaderInfo;
